import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLandingSettings } from '../useLandingSettings';
import { LandingButton } from './LandingButton';

export const LandingHeader: React.FC = () => {
  const { productLogo, partnerLogo } = useLandingSettings();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-30 w-full bg-[#fbf7ef]/90 backdrop-blur-sm">
      <div className="mx-auto flex max-w-[1180px] items-center justify-between gap-3 px-4 py-3 md:px-8 md:py-3.5">
        <Link to="/" className="flex min-w-0 items-center gap-2 md:gap-3">
          <img
            src={productLogo}
            alt="OneHealth"
            className="h-5 w-auto shrink-0 md:h-7"
          />
          <span className="text-2xl font-light text-[#9aa0a6] leading-none">
            +
          </span>
          {partnerLogo && (
            <img
              src={partnerLogo}
              alt="Partner"
              className="h-5 w-auto min-w-0 object-contain md:h-7"
            />
          )}
        </Link>

        <LandingButton
          onClick={() => navigate('/form')}
          showArrow={false}
          className="font-['Inter'] text-[16px] font-light normal-case leading-none text-white h-10 shrink-0 px-4 py-0 text-[12px] md:h-11 md:px-7 md:text-[20px]"
        >
          Get a quote
        </LandingButton>
      </div>
    </header>
  );
};
